import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "mt-5 is-centered buttons" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_dialog = _resolveComponent("modal-dialog")!

  return (_openBlock(), _createBlock(_component_modal_dialog, { ref: "dialog" }, {
    content: _withCtx(() => [
      _createElementVNode("p", {
        class: "is-size-5 mt-4 mb-2 has-text-weight-semibold animate__animated animate__fadeInDown animate__fast",
        innerHTML: _ctx.title
      }, null, 8, _hoisted_1),
      _createElementVNode("p", {
        class: "is-size-6 mb-4 has-text-grey animate__animated animate__fadeInUp animate__fast",
        innerHTML: _ctx.message
      }, null, 8, _hoisted_2),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: option,
            class: _normalizeClass(["button animate__animated animate__fadeInUpSmall animate__delay-400ms animate__faster", { 'is-black': index === 0 }]),
            onClick: ($event: any) => (_ctx.optionSelected(index))
          }, _toDisplayString(option), 11, _hoisted_5))
        }), 128))
      ])
    ]),
    _: 1
  }, 512))
}